import { Link } from "react-router-dom";
import { categoryLabel, formatPrice } from "@/lib/data";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group block"
    >
      <div className="relative spotlight">
        <div className="overflow-hidden rounded-xl border border-line bg-surface">
          <div className="aspect-square overflow-hidden">
            <img
              src={product.image_url}
              alt={product.name}
              loading={index > 3 ? "lazy" : "eager"}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
          </div>
        </div>
        {product.stock <= 2 && (
          <span className="absolute top-4 left-4 rounded-full bg-ink/80 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-widest2 text-gold border border-gold/30">
            {product.stock === 1 ? "One of one" : "Almost gone"}
          </span>
        )}
      </div>
      <div className="mt-4 flex items-baseline justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-widest2 text-sage/80">{categoryLabel(product.category)}</p>
          <h3 className="mt-1 font-display text-xl text-paper leading-snug group-hover:text-gold transition-colors duration-300">
            {product.name}
          </h3>
        </div>
        <p className="font-display text-lg text-gold whitespace-nowrap">
          {product.variants?.length > 0 ? `from ${formatPrice(Math.min(...product.variants.map((v) => v.price)))}` : formatPrice(product.price)}
        </p>
      </div>
    </Link>
  );
}
